import React from 'react';
import { COLORS } from '../designSystem';

export default function StatusBadge({ status, size = 'md' }) {
  if (!status) return null;

  const statusConfig = {
    draft: {
      bg: COLORS.STATUS_DRAFT_BG,
      text: COLORS.STATUS_DRAFT_TEXT,
      label: 'Draft',
    },
    funded: {
      bg: COLORS.STATUS_FUNDED_BG,
      text: COLORS.STATUS_FUNDED_TEXT,
      label: 'Funded',
    },
    performing: {
      bg: COLORS.PRIMARY,
      text: COLORS.TEXT_WHITE,
      label: 'Performing',
    },
    collections: {
      bg: COLORS.WARNING,
      text: '#000000',
      label: 'Collections',
    },
    default: {
      bg: COLORS.ERROR,
      text: COLORS.TEXT_WHITE,
      label: 'Default',
    },
    closed_complete: {
      bg: COLORS.STATUS_CLOSED_BG,
      text: COLORS.STATUS_CLOSED_TEXT,
      label: 'Closed (Complete)',
    },
    closed_incomplete: {
      bg: COLORS.STATUS_CLOSED_BG,
      text: COLORS.STATUS_CLOSED_TEXT,
      label: 'Closed (Incomplete)',
    },
  };

  const config = statusConfig[status] || statusConfig.draft;
  const sizeStyles = size === 'sm' ? { padding: '3px 8px', fontSize: '11px' } : { padding: '4px 12px', fontSize: '12px' };

  return (
    <span
      style={{
        display: 'inline-block',
        backgroundColor: config.bg,
        color: config.text,
        borderRadius: '24px',
        fontWeight: '600',
        ...sizeStyles,
      }}
    >
      {config.label}
    </span>
  );
}
